// @ts-nocheck
import { InvoicesDataViewContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AccountLayout from "@store/Library/Components/Toolkit/Layout/AccountLayout";
import React, { useContext } from "react";

export interface InvoiceHistoryPageContainerStyles {}

export const invoiceHistoryPageContainerStyles: InvoiceHistoryPageContainerStyles = {};

const styles = invoiceHistoryPageContainerStyles;

const InvoiceHistoryPageContainer = ({ id }: WidgetProps) => {
    const invoicesDataView = useContext(InvoicesDataViewContext);

    return <AccountLayout id={id} contentDataView={invoicesDataView} />;
};

const widgetModule: WidgetModule = {
    component: InvoiceHistoryPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Invoice History",
        allowedContexts: ["InvoiceHistoryPage"],
    },
};
export default widgetModule;
